import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-747ef52f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "second-level-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"0.6rem"} }, null, -1))

import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'SecondPageHeader',
  props: {
  isShowBackButton: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
  },
  toPath: {
    type: String,
  },
  query: {
    type: Object,
    default: {},
  },
},
  setup(__props) {

const props = __props


const router = useRouter();
const handleToPath = () => {
  router.push({
    path: props.toPath,
    query: props.query,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_el_icon, {
      style: {"font-size":"0.3rem","margin-left":"0.3rem"},
      class: _normalizeClass({ 'icon-hidden': !__props.isShowBackButton }),
      onClick: handleToPath
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ArrowLeftBold)
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("h4", null, _toDisplayString(__props.title), 1),
    _hoisted_2
  ]))
}
}

})